import { Component, OnInit, TemplateRef, EventEmitter, Output, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {

  @ViewChild('text') text:ElementRef;

  title: string;
  message: string;
  options: string[];
  answer: string = "";
  input: boolean;
  inputPlaceholder: string;
  inputText: string = "";
  enableSpeech: boolean = false;
  validateInput:string = "";
  invalid: boolean = false;
  timeout: number;
  timer:number;
  private speechApi: boolean;
  sub: any;

  constructor(
    public bsModalRef: BsModalRef,
    private speechRecognitionService:SpeechRecognitionService
  ) { }

  ngOnInit() {
    if ('webkitSpeechRecognition' in window)
    {
      this.speechApi = true;
    }
    else
    {
      this.speechApi = false;
    }
    this.inputText = "";

    if (this.timeout){
      this.timer = this.timeout;
      let timer = Observable.timer(0, 1000);
      this.sub = timer.subscribe(t => this.incrementTimer(this.timeout));
    }
  }

  incrementTimer(timeout: number) {
    this.timer--;
    if (this.timer == 0) {
      this.respond("Cancel")
      this.sub.unsubscribe();
    }
  }

  respond(answer: string) {
    if (this.validateInput && (answer == "OK" || answer == "YES")){
      if(this.text.nativeElement.value != this.validateInput){
        this.invalid = true;
      }
      else {
        this.answer = answer;
        this.bsModalRef.hide();
      }
    }
    else {
      this.answer = answer;
      this.bsModalRef.hide();
    }
  }

  onChange(){
    if (this.validateInput){
      if (this.text.nativeElement.value == this.validateInput){
        this.invalid = false;
      }
    }
  }

  activateSpeech(): void {
    //this.showSearchButton = false;

    this.speechRecognitionService.record()
        .subscribe(
        //listener
        (value) => {
            this.inputText = value;
            console.log(value);
        },
        //error
        (err) => {
            console.log(err);
            if (err.error == "no-speech") {
                console.log("--restarting service--");
                this.activateSpeech();
            }
        },
        //completion
        () => {
            //this.showSearchButton = true;
            console.log("--complete--");
            //this.activateSpeech();
        });
  }

  ngOnDestroy(){
    if (this.sub){
      this.sub.unsubscribe();
    }
  }
}
